export default {
  online_shop: 'Onlinebutik',
  storefront: 'Butiksfacade',
  reservations: 'Reservationer',
  import: 'Import',
};
